import { IfFeatureState_Core } from 'core';
import {
  ClickableOptionsCard,
  EditProfileModal,
  TransferAccountsModalGroup,
} from 'core/Components';
import { Stack, Title } from 'ui';
import { useDisclosure } from 'ui/Hooks';

import { ChangePasswordModalGroup } from '../../Profile/EditProfile/ChangePasswordGroup';
import { DirectorySettings } from './DirectorySettings/DirectorySettings';

const ProfileActions = () => {
  const [isEditProfileOpened, editProfileHandlers] = useDisclosure(false);
  return (
    <>
      <Stack>
        <Title order={2}>Profile</Title>
        <ClickableOptionsCard variant="gray">
          <ClickableOptionsCard.Row title="Edit Profile" onClick={editProfileHandlers.open} />
          <IfFeatureState_Core featureId="internalPreview">
            <DirectorySettings />
          </IfFeatureState_Core>
          <ChangePasswordModalGroup />
          <TransferAccountsModalGroup
            openButton={(props) => (
              <ClickableOptionsCard.Row
                onClick={() => props.openModalById('LinkedAccounts')}
                title="Linked Accounts"
              />
            )}
          />
        </ClickableOptionsCard>
      </Stack>
      <EditProfileModal opened={isEditProfileOpened} onClose={editProfileHandlers.close} />
    </>
  );
};

export { ProfileActions };
